import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import EventHero from './components/EventHero';
import EventGrid from './components/EventGrid';
import SeoHead from '../../components/feature/SeoHead';

export default function EventGallery() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

  const eventJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'ImageGallery',
    name: 'Malfi Coffee – Event Gallery',
    description: 'Browse photos from Malfi Coffee events including festivals, corporate catering, weddings, workshops, and community gatherings in Orange County, CA.',
    url: `${siteUrl}/event-gallery`,
    author: {
      '@type': 'Organization',
      name: 'Malfi Coffee',
      url: siteUrl,
    },
  };

  return (
    <div className="min-h-screen bg-[#FFF8E7]">
      <SeoHead
        title="Event Gallery – Malfi Coffee | Coffee &amp; Lemonade Catering Events"
        description="See Malfi Coffee in action! Browse our event gallery featuring festivals, corporate coffee tastings, weddings, workshops, and community events in Orange County, CA."
        keywords="malfi coffee events, coffee catering gallery, Orange County event catering, Malfi Coffee events"
        canonical={`${siteUrl}/event-gallery`}
        jsonLd={eventJsonLd}
      />
      <Navbar />

      <EventHero />

      <EventGrid />

      {/* CTA Section */}
      <section className="py-20 px-4 bg-[#2C5F2D] text-white">
        <div className="max-w-4xl mx-auto text-center">
          <h2
            className="text-4xl md:text-5xl font-bold mb-6"
            style={{ fontFamily: 'Georgia, serif' }}
          >
            Want Us at Your Next Event?
          </h2>
          <p className="text-xl mb-8 leading-relaxed">
            From intimate gatherings to large-scale festivals, we bring the perfect blend of
            refreshing lemonades and bold coffees to make your event unforgettable.
          </p>
          <Link
            to="/contact#name"
            className="inline-block bg-[#FFD700] text-[#2C5F2D] px-10 py-4 rounded-full text-lg font-bold hover:bg-[#FFC700] transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            BOOK US FOR YOUR EVENT
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}
